import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-488ff3f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-pdo-submission-new-submitted" }

import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';
  import { mineBreadcurmbStore } from '@/stores';
  import SubmitSuccess from '@/components/offline-collection/submit-success.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const { t } = useI18n();

  onMounted(() => {
    mineBreadcurmbStore.update([
      { name: t('PDO Dashboard'), to: { name: 'pdo.programs' } },
      { name: String(route.query.title), to: { name: 'pdo.program', params: { id: 1 } } },
      { name: t('Submission') }
    ]);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SubmitSuccess, { type: "PDO" })
  ]))
}
}

})